export enum TagProfile {
  None,
  Unrecognised,
  Permitted,
  Safe,
  NotPermitted,
  Intruder,
}
